module.exports = __webpack_public_path__ + "img/sentra3.df49fa73.jpeg";